import {AccessTypeKeyName, SiarEventTypeEnum} from '@/features/access-types/types'
import {ProjectType} from '@/features/projects/types'
import {TKey} from '@/translations/i18n'

export const disabledAccessTypeByProjectType = {
    cyclic: ['project_opening_processing', 'project_closing_processing'],
    continuous: ['cycle_opening_processing', 'cycle_closing_processing']
} as const satisfies Record<ProjectType, AccessTypeKeyName[]>

export const siarEventTypeToLabel = {
    medical_access: 'commons:siar_event_type_medical_access',
    rehabilitation_therapist_access: 'commons:siar_event_type_rehabilitation_therapist_access',
    psychosocial_access: 'commons:siar_event_type_psychosocial_access',
    other: 'commons:other'
} as const satisfies Record<SiarEventTypeEnum, TKey>
